import axios from 'axios';

import getHeaderToken from 'functions/getHeaderToken';

import{ Logger } from 'aws-amplify';
const logger = new Logger('CorporationCollaboration-log');

const deleteCorporationCollaboration = async (url, corporationOfficeNumber, facilityOfficeNumber, collaborations, setCollaborations) => {

    const deleteData = {
        corporation_office_number: corporationOfficeNumber,
        facility_office_number: facilityOfficeNumber
    };
    const header = await getHeaderToken();
    const config = Object.assign(header, { data: deleteData });
    const error_message = '連携施設の削除に失敗しました。\n\nステータスコード：'

    axios
        .delete(url, config)
        .then((res) => {
            if (res.status === 204) {
                let updatedCollaborations = collaborations.filter(
                    c => c.facility_office_number !== facilityOfficeNumber
                );
                setCollaborations(updatedCollaborations);
            } else {
                logger.error(res);
                window.alert(error_message + res.status);
            }
        })
        .catch((e) => {
            logger.error(e);
            window.alert(error_message + e.response.status);
        });

};

export default deleteCorporationCollaboration;
